import React from 'react';

const AuthenticatedRouteLanguageContext = React.createContext({});

AuthenticatedRouteLanguageContext.displayName = 'AuthenticatedRouteLanguageContext';

export default AuthenticatedRouteLanguageContext;
